import styled from 'styled-components';
import GroupSelector from './component';

export default styled(GroupSelector)`
  span:first-child {
    // ORC checkbox
    margin: 0;
    min-width: 16px;
    max-width: 16px;
    max-height: 16px;

    svg {
      width: 12px;
      height: 12px;
    }
  }
`;
